export const redditAnalyticsEvents = {
	SIGNUP_REQUEST: 'CompleteRegistration',
	CREDITS_OVER: 'Lead',
	GENERATE_BUTTON: 'Search',
	BEGIN_CHECKOUT: 'InitiateCheckout',
	PURCHASE_SUCCESSFULL: 'Purchase',
};
